const TicketTypeCard = ({ ticket, onEdit, onDelete }) => {
  return (
    <article className="flex flex-col rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition hover:shadow-md">
      <div className="flex-1">
        <h3 className="text-base font-semibold text-gray-900">{ticket.name}</h3>
        {ticket.description && (
          <p className="mt-1 line-clamp-2 text-xs text-gray-500">{ticket.description}</p>
        )}
        <p className="mt-3 text-2xl font-bold text-gray-900">{ticket.displayPrice}</p>
        <ul className="mt-3 space-y-1 text-sm text-gray-600">
          <li className="flex items-center gap-2">
            <i className="fi fi-rr-check text-emerald-500 text-xs" />
            {ticket.inclusionCount} Inclusion{ticket.inclusionCount !== 1 ? "s" : ""}
          </li>
          <li className="flex items-center gap-2">
            <i className="fi fi-rr-cross text-gray-400 text-xs" />
            {ticket.exclusionCount} Exclusion{ticket.exclusionCount !== 1 ? "s" : ""}
          </li>
          <li className="flex items-center gap-2">
            <i className="fi fi-rr-calendar text-gray-400 text-xs" />
            {ticket.itineraryCount} Itinerary item{ticket.itineraryCount !== 1 ? "s" : ""}
          </li>
        </ul>
      </div>
      <div className="mt-4 flex gap-2">
        <button
          type="button"
          onClick={() => onEdit(ticket)}
          className="flex-1 rounded-xl border border-gray-200 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50"
        >
          Edit
        </button>
        <button
          type="button"
          onClick={() => onDelete?.(ticket)}
          className="rounded-xl border border-red-100 px-3 py-2 text-sm text-red-600 transition hover:bg-red-50"
          title="Delete ticket"
        >
          <i className="fi fi-rr-trash" />
        </button>
      </div>
    </article>
  );
};

export default TicketTypeCard;
